import React, {useState} from 'react';
import DatePicker from "react-datepicker";
import PropTypes from 'prop-types'

const MonthPickerInput = ({label, className, isRequired, id}) => {
  const [startDate, setStartDate] = useState(new Date());

  return (
    <div className={`form-item month-picker ${className}`}>
      <DatePicker
        id={id}
        selected={startDate}
        onChange={date => setStartDate(date)}
        dateFormat="MMMM"
        showMonthYearPicker
        required={isRequired}
        className="date-picker"
      />
      {label && <label htmlFor={id}
        className={isRequired && 'required'}>{label}</label>}
    </div>
  );
};

MonthPickerInput.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  isRequired: PropTypes.bool,
  id: PropTypes.string,
}

MonthPickerInput.defaulProps = {
  isRequired: false,
  id: '',
}

export default MonthPickerInput;
